export var WriterFlags;
(function (WriterFlags) {
    WriterFlags[WriterFlags["None"] = 0] = "None";
    WriterFlags[WriterFlags["Runtime"] = 1] = "Runtime";
    WriterFlags[WriterFlags["Execution"] = 2] = "Execution";
    WriterFlags[WriterFlags["Interpreter"] = 4] = "Interpreter";
})(WriterFlags || (WriterFlags = {}));
